/* Copyright 2020 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the events associated with it. This
 * information is used in order to dispatch the correct events to the peer model. This is also used
 * to map events to actions registered with the action service.
 */

define([
        "MW/statusbar/TypeConstants"
], function (TypeConstants) {
    
    var hash = {};

    // Status bar controls:
    hash[TypeConstants.STATUS_PUSH_BUTTON] = {
        actionEvents: ["buttonPushed"],
        componentEvents: []
    };

    hash[TypeConstants.STATUS_TEXT_FIELD] = {
        actionEvents: ["focusGained", "focusLost", "typing", "textCancelled", "recommit"],
        componentEvents: []
    };

    hash[TypeConstants.STATUS_TOGGLE_BUTTON] = {
        actionEvents: [],
        componentEvents: []
    };

    return hash;
});